import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
} from '@angular/core';
import { secondsToDuration } from '@dxp/core/helpers';
import { FormatDurationPipe } from '@dxp/core/pipes';
import { HeartbeatService } from '@dxp/core/services';
import { Duration } from 'date-fns';

@Component({
    selector: 'telxl-shared-timer-count',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormatDurationPipe],
    templateUrl: './timer-count.component.html',
    styleUrl: './timer-count.component.scss',
})
export class TelXLTimerCountComponent {
    readonly #heartbeatService = inject(HeartbeatService);

    inputDate = input.required<Date>();

    readonly #now = this.#heartbeatService.lastHeartbeat;

    readonly timerCount = computed<Duration>(() => {
        const now = this.#now();

        const timer = Math.round(
            (now.getTime() - new Date(this.inputDate()).getTime()) / 1000,
        );

        return secondsToDuration(timer);
    });
}
